import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.find";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { Fragment } from 'react';
import { useComponents } from 'docz';
import { MDXProvider } from '@mdx-js/react';
import { propEq, get } from 'lodash/fp';
import { useDbQuery } from '../hooks/useDbQuery';
import Wrapper from '../wrapper';
import Theme from '../index';
import SEO from './Seo';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Route = function Route(_ref) {
  var children = _ref.children,
      entry = _ref.entry,
      defaultProps = _objectWithoutPropertiesLoose(_ref, ["children", "entry"]);

  var components = useComponents();
  var NotFound = components.notFound;
  var Layout = components.layout;

  var props = _objectSpread({}, defaultProps, {
    doc: entry
  });

  if (!entry) return ___EmotionJSX(NotFound, null);
  return ___EmotionJSX(MDXProvider, {
    components: components
  }, ___EmotionJSX(Wrapper, {
    doc: entry
  }, ___EmotionJSX(Layout, props, children)));
};

var findEntry = function findEntry(db, ctx) {
  var isIndex = ctx.frontmatter && ctx.frontmatter.route === '/';
  var eqIndex = propEq('value.route', '/');
  if (!ctx.entry && isIndex) return db.entries.find(eqIndex);
  var filepath = get('entry.filepath', ctx);
  return db.entries.find(propEq('value.filepath', filepath));
};

var Layout = function Layout(_ref2) {
  var children = _ref2.children,
      defaultProps = _objectWithoutPropertiesLoose(_ref2, ["children"]);

  var ctx = defaultProps.pageContext;
  var db = useDbQuery();
  var entry = findEntry(db, ctx);
  return ___EmotionJSX(Fragment, null, entry && ___EmotionJSX(SEO, {
    title: entry.value.name
  }), ___EmotionJSX(Theme, {
    db: db,
    currentEntry: entry
  }, ___EmotionJSX(Route, _extends({}, defaultProps, {
    entry: entry
  }), children)));
};

export default Layout;

if (typeof Layout !== 'undefined' && Layout && Layout === Object(Layout) && Object.isExtensible(Layout) && !Layout.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Layout, '__filemeta', {
    configurable: true,
    value: {
      name: "Layout",
      filename: "node_modules/gatsby-theme-docz/src/base/Layout.js"
    }
  });
}